




import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { EntityFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { UserFilterParameter } from ".";
import DesignatedDoctorDropDownSelector from "../../designatedDoctor/selectors/DesignatedDoctorDropDownSelector.vue";
import { DesignatedDoctorInformation, User } from "../../../domain/user";

@Component({
  components: {
    StringFilter,
    DesignatedDoctorDropDownSelector,
  },
})
export default class DesignatedDoctorUserFilter extends Mixins(ModelEditableMixin) {
  editingSource: UserFilterParameter;

  @Prop()
  designatedDoctorInformations: DesignatedDoctorInformation[];

  get designatedDoctorInformationsSource(): DesignatedDoctorInformation[] {
    return this.designatedDoctorInformations;
  }

  set designatedDoctorInformationsSource(source: DesignatedDoctorInformation[]) {
    this.$emit("update:designatedDoctorInformations", source);
  }

  @Watch("designatedDoctorInformations", { immediate: true })
  onProjectTeamChanged(newValue: DesignatedDoctorInformation[], oldValue: DesignatedDoctorInformation[]) {
    this.updateDesignatedDoctorUsers();
  }

  updateDesignatedDoctorUsers(): void {
    const users = this.designatedDoctorInformations
      ? Enumerable.from(this.designatedDoctorInformations).select(s => this.toUser(s)).toArray()
      : null;
    this.designatedDoctorUsers = new EntityFilterParameter(users);
  }

  private toUser(designatedDoctor: DesignatedDoctorInformation): User {
    return new User(designatedDoctor.userId, null, null, null, null, null);
  }

  get designatedDoctorUsers(): EntityFilterParameter {
    return this.editingSource.designatedDoctorUsers;
  }

  set designatedDoctorUsers(source: EntityFilterParameter) {
    this.writeProperty(s => s.designatedDoctorUsers = source);
  }
}
